let slickPromise;

export function loadSlick() {
  if (!slickPromise) {
    slickPromise = Promise.all([
      import('slick-carousel/slick/slick.css'),
      import('slick-carousel/slick/slick-theme.css'),
      import('slick-carousel')
    ]);
  }
  return slickPromise;
}